<template>
  <v-flex>
    <v-card>
      <v-list subheader>
        <v-subheader>Foldery</v-subheader>

        <v-list-tile v-for="folder in folders" :key="folder.title" avatar>
          <router-link :to="`/filetree/${folder.id}`" class="no-underline">
            <v-list-tile-avatar>
              <v-icon v-if="folder.id == 0" class="error white--text">delete_outline</v-icon>
              <v-icon v-if="folder.id != 0" class="secondary white--text">folder</v-icon>
            </v-list-tile-avatar>
          </router-link>
          <v-list-tile-content>
            <v-list-tile-title>
              <router-link :to="`/filetree/${folder.id}`" class="no-underline">{{ folder.name }}</router-link>
            </v-list-tile-title>
            <v-list-tile-sub-title
              v-if="folder.FileTreeChanges.length > 0"
            >{{ folder.FileTreeChanges[0].createdAt | humanDate }} - {{folder.FileTreeChanges[folder.FileTreeChanges.length-1].text}}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-menu bottom left v-if="folder.id != 0">
              <v-btn icon slot="activator">
                <v-icon>more_horiz</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="$emit('showModifyFolderDialog', folder)">
                  <v-list-tile-title>Edytuj</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="$emit('showDeleteDialog', folder)">
                  <v-list-tile-title>Usuń</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: ["folders"],
  data: () => ({})
};
</script>

<style scoped>
.user-info {
  width: 100%;
  margin: 0;
}
.no-underline {
  text-decoration: none;
  color: inherit;
}
.no-bg {
  background: none;
}
</style>
